import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // keep these up to date with @/styles/_variables.scss
        primary: '#6484ff',
        primaryDark: '#242E4C',
        lightGrey: '#eee',
        buttonLightblue: '#27aae1',
        buttonGreen: '#50b848',
        buttonOrange: '#f47920',
        buttonRed: '#ff0000',
        buttonGrey: '#53565A',
        buttonWhite: '#D0D0CE',
        buttonYellow: '#CEDC00',
        buttonCyan: '#00B0B9',
        buttonTeal: '#337079',
        buttonBlue: '#005C89',
        calendarGreen: '#0dac30',
        calendarRed: '#FF454B',
      },
    },
  },
});
